import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import activeProductReducer from "./activeProduct/reducer";
import favoritesReducer from "./favorites/reducer";
import subscriptionsReducer from "./toggleFilters/reducer";
import gridModeReducer from "./gridMode/reducer";
import priceModeReducer from "./priceMode/reducer";
import { verwimpApi } from "./service";
import sessionReducer from "./session/reducer";
import shoppingCartReducer from "./shoppingCart/reducer";
import loadedProductsReducer from "./loadedProducts/reducer";
import activeQueryReducer from "./activeQuery/reducer";
import activeCategoryReducer from "./activeCategory/reducer";

const rootReducer = combineReducers({
  activeCategory: activeCategoryReducer,
  activeProduct: activeProductReducer,
  activeQuery: activeQueryReducer,
  session: sessionReducer,
  shoppingCart: shoppingCartReducer,
  favorites: favoritesReducer,
  subscriptions: subscriptionsReducer,
  priceMode: priceModeReducer,
  gridMode: gridModeReducer,
  loadedProducts: loadedProductsReducer,
  [verwimpApi.reducerPath]: verwimpApi.reducer,
});

export default function createStore() {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(verwimpApi.middleware),
  });

  setupListeners(store.dispatch);

  return store;
}
